// extracted by mini-css-extract-plugin
export default {"title":"Kba-z","warning":"Lba-z","sizeOptionsLegendText":"Mba-z"};